export class RefCultureBio {
    id: number;
    code: string;
    libelle: string;
}
